import { Button, Input, Popover } from "antd";

import { useState } from "react";

import { userRoles } from "@evolved/constants";
import {
  useOrganization,
  useResetOrganization,
} from "../data/use-organization";
import { useMe } from "../data/use-me";
import { useInternal } from "../hooks/use-internal";

export const ResetOrganization = (props) => {
  const user = useMe();
  const organization = useOrganization();
  const resetOrganization = useResetOrganization();

  const isOn = useInternal();
  const [isOpen, setIsOpen] = useState(false);

  const [confirmText, setConfirmText] = useState("");

  if (!isOn) {
    return null;
  }

  if (user.role > userRoles.ROLES.MANAGER) {
    return null;
  }

  return (
    <Popover
      content={
        <div style={{ width: "325px" }}>
          <div>
            This will permanently delete all of your user data. This action is
            irreversible.
          </div>
          <div style={{ margin: "8px 0px" }}>
            Input your organization name <strong>{organization.name}</strong> to
            confirm.
          </div>
          <Input
            value={confirmText}
            onChange={(e) => {
              setConfirmText(e.target.value);
            }}
          />
          <div style={{ margin: "8px 0px", display: "flex" }}>
            <Button
              size="small"
              type="default"
              onClick={() => {
                setIsOpen(false);
              }}
              style={{ margin: "0px 4px 0px auto" }}
            >
              No
            </Button>
            <Button
              size="small"
              type="primary"
              disabled={confirmText !== organization.name}
              onClick={() => {
                setIsOpen(false);
                resetOrganization.mutate();
              }}
            >
              Yes
            </Button>
          </div>
        </div>
      }
      open={isOpen}
      onOpenChange={setIsOpen}
      title="Warning"
      trigger="click"
    >
      <Button
        danger
        ghost
        loading={resetOrganization.isLoading}
        disable={resetOrganization.isLoading}
        type="primary"
        style={props.style}
      >
        Reset Organization
      </Button>
    </Popover>
  );
};
